import { Vector3 } from "three";
import React, { useEffect, useState } from "react";
import Paneel from "../../doors/paneel";
import { ConfigurationProps } from "../../Door";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";
import { mirrorVerticalBeamPosition } from "entities/configurator/model/layoutMeta";

interface DoublePanelProps extends ConfigurationProps {}

const DoublePaneel: React.FC<DoublePanelProps> = ({
  materials,
  position,
  scale,
  rotation,
}: DoublePanelProps) => {
  const panelPosition0 = new Vector3(-0.459, 0, 0);
  const panelPosition1 = new Vector3(0.459, 0, 0);

  const { eigenwijs, getConfigurationPositions, sceneStaanderPosition } =
    useConfigurationOptionsContext();

  const [positions, setPositions] = useState<Vector3[]>([]);

  useEffect(() => {
    setPositions(getConfigurationPositions([panelPosition0, panelPosition1]));
  }, [eigenwijs?.sizeObjects]);

  const secondaryVerticalBeamPosition = mirrorVerticalBeamPosition(
    sceneStaanderPosition,
  );

  return (
    <group position={position} scale={scale}>
      <Paneel
        materials={materials}
        position={positions[0]}
        index={0}
        rotation={rotation}
        rotateNewlayouts={true}
        verticalBeamPosition={sceneStaanderPosition}
      />
      <Paneel
        materials={materials}
        position={positions[1]}
        index={1}
        verticalBeamPosition={secondaryVerticalBeamPosition}
      />
    </group>
  );
};

export default DoublePaneel;
